import React from "react";
import { styled, SxProps, Link, Card, Typography, Stack, IconButton } from "@mui/material";
import TitleItem from "../../Lists/TitleItemList/TitleItem";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { thumbnailService } from "../../../Core/Api/services";
import { useTranslation } from "react-i18next";

export type TitleCollectionCardProps = {
  className?: string;
  sx?: SxProps;
  poster?: string;
  id?: number;
  title: string;
  desc?: string;

  status?: "added" | "none" | "just-added" | "share" | "select-share";
  onClickAdd: () => void;
  onClickRemove: () => void;
  onClickEdit?: () => void;
  onClickSelect?: () => void;
};

const TitleCollectionCard: React.FC<TitleCollectionCardProps> = (props) => {
  const { t } = useTranslation();
  const {
    title,
    poster,
    desc,
    id,
    status = "none",
    onClickAdd,
    onClickRemove,
    onClickEdit,
    onClickSelect,
    ...otherProps
  } = props;

  const [_status, setStatus] = React.useState(status);

  const handleClickAdd = () => {
    // setStatus("just-added");
    onClickAdd();
  };

  React.useEffect(() => {
    setStatus(status);
  }, [status]);

  let _renderedStatus = <></>;
  switch (_status) {
    case "added":
      _renderedStatus = (
        <Stack direction="row" alignItems="center">
          <Typography color="text.tier" variant="body1" flexShrink={0}>
            {t("card:titleCollectionCard.body.alreadyInCollection")}
          </Typography>
          <IconButton color="error" onClick={onClickRemove}>
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </Stack>
      );
      break;
    case "just-added":
      _renderedStatus = (
        <Typography color="primary.text" variant="body2" sx={{ display: "flex", alignItems: "center" }}>
          <CheckIcon fontSize="small" sx={{ mr: 1 }} />
          {t("common:added")}
        </Typography>
      );
      break;
    case "share":
      //   _renderedStatus = (
      //     <Stack direction="row" alignItems="center">
      //       <EditOutlinedIcon fontSize="small" onClick={onClickEdit} />
      //     </Stack>
      //   );
      break;
    case "select-share":
      _renderedStatus = (
        <Stack direction="row" alignItems="center">
          <EditOutlinedIcon fontSize="small" onClick={onClickEdit} />
        </Stack>
      );
      break;
    default:
      _renderedStatus = (
        <Link component="button" variant="body2" underline="hover" color="text.primary" onClick={handleClickAdd}>
          <AddIcon fontSize="small" /> {t("common:addToCollection")}
        </Link>
      );
      break;
  }

  return (
    <StyledCard variant="outlined" {...otherProps} onClick={onClickSelect}>
      <TitleItem size="small" title={title} desc={desc} poster={poster} sx={{ flex: 0.8 }} />
      {_renderedStatus}
    </StyledCard>
  );
};

export default TitleCollectionCard;

const StyledCard = styled(Card)(({ theme }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(2)} ${theme.spacing(1)}  ${theme.spacing(1)}`,
  display: "flex",
  justifyContent: "space-between",
}));
